import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Button, FormLabel, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import withRouter from 'js/withRouter';
import _ from 'lodash';
import { getNameInCurrentLanguage } from 'helpers/intl';
import MainMenuLinkNotification from 'components/layout/mainMenus/common/MainMenuLinkNotification';
import MainMenuLink from "components/layout/mainMenus/common/MainMenuLink";
import {
  getAllNotificationsR,
  socketConnectNotifications,
  setAsReadR
} from 'actions/RealTimeNotificationActions';
import {addNotification} from "actions/NotificationsActions";
import IntlDate from "components/layout/IntlDate";
import { entityMetaMapping } from 'js/constants';


class NotificationMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMessages: 5,
      unreadNotifications: 0,
    };
    this.index = 1300;
  }

  componentDidMount = () => {
    const { user, getAllNotificationsR, connectNotificationsSocket } = this.props;
    getAllNotificationsR({ clientId: user.username });
    connectNotificationsSocket();
  };

  componentDidUpdate = prevProps => {
    const { doNotify, notifications, latestNotification, history, appIntl, goToData, setAsReadR, intl: { messages } } = this.props;
    let notification;
    const { unreadNotifications } = this.state;
    let _unreadNotifications = unreadNotifications;
    let actionFlag = latestNotification?.entityDocIdentifier || latestNotification?.entity_doc_identifier;
    let actionTitle = "";
    if (actionFlag === entityMetaMapping.edition) {
      actionTitle = messages.go_to_edition;
    } else if (actionFlag === entityMetaMapping.orderItem) {
      actionTitle = messages.go_to_order;
    }


    if (prevProps.latestNotification?.cdate !== latestNotification?.cdate) {
      notification = (
        <>
          <IntlDate date={latestNotification?.cdate} />
          <br/>
          <span>{latestNotification?.title}</span>
          <br/>
          <span>{latestNotification?.description}</span>
        </>
      );
      doNotify(2, notification, latestNotification?.id, actionTitle);
    }

    if (prevProps.notifications.length !== notifications.length || JSON.stringify(prevProps.notifications) !== JSON.stringify(notifications)) {
      _unreadNotifications = 0;
      _.forEach(notifications, notification => {
        if (!notification.read) {
         _unreadNotifications++;
        }
      });

      this.setState({ unreadNotifications: _unreadNotifications }, () => {});
    }

    if (goToData && prevProps.goToData?.id !== goToData?.id && actionFlag === entityMetaMapping.edition) {
      const index = _.findIndex(notifications, notification => notification.id === goToData?.id);
      setAsReadR(goToData?.id);
      let editionId = notifications?.[index]?.entity_id || notifications?.[index]?.entityId;
      let url = appIntl.urlPrefix + 'editor/' + editionId;
      /** as an alternative to a hard reload we could use -> window.location.href = url; */
      history.push(url);
    } else if (goToData && prevProps.goToData?.id !== goToData?.id && actionFlag === entityMetaMapping.orderItem) {
      const index = _.findIndex(notifications, notification => notification.id === goToData?.id);
      setAsReadR(goToData?.id);
      let orderId = notifications?.[index]?.metadata?.parent_entity_id || notifications?.[index]?.metadata?.parentEntityId;
      let url = appIntl.urlPrefix + 'account/orders/' + orderId;
      history.push(url);
    }


  };

  showMoreMessages = (event) => {
    event.stopPropagation();
    this.setState(prevState => ({
      showMessages: prevState.showMessages + 5,
    }));
  };

  showLessMessages = () => {
    this.setState(prevState => ({
      showMessages: prevState.showMessages - 5,
    }));
  };

  renderNotification = ({ id, cdate, description, entityId, entity_id, read, title, type, entityDocIdentifier, entity_doc_identifier, metadata }) => {
    const { intl: { messages } } = this.props;
    let actionFlag = entityDocIdentifier || entity_doc_identifier;
    let actionId = entityId || entity_id;
    if (actionFlag === entityMetaMapping.orderItem) {
      actionId = metadata?.parent_entity_id || metadata?.parentEntityId;
    }
    return (
      <li className="notification-li" key={id}>
        <div className="rendered-notification padding-15" style={{ width: '100%', cursor: 'pointer', borderBottom: '1px solid #e1e1e1' }} onClick={()=>{this.notificationAction(actionFlag, actionId, id)}}>
          {read ?
            <>
              <h6>
                <IntlDate date={cdate} />
              </h6>
              <h5>
                  <span>
                    <i className="fa-light fa-envelope-open" /> {title}
                  </span>
              </h5>
              <h6 style={{textAlign: "left"}}>
                <span>
                  {description}
                </span>
              </h6>

            </>
            :
            <>
              <h6>
                <strong>
                  <IntlDate date={cdate} />
                </strong>
              </h6>
              <h5>
                <strong>
                  <span>
                    <i className="fa-solid fa-envelope" /> {title}
                  </span>
                </strong>
              </h5>
                <h6 style={{textAlign: "left"}}>
                  <strong>
                    <span>
                      {description}
                    </span>
                  </strong>
                </h6>
            </>
          }
        </div>
      </li>
    );
  };


  notificationAction = (action, entityId, id) => {
    const { history, appIntl, intl: { messages }, setAsReadR } = this.props;
    setAsReadR(id);
    if (action === entityMetaMapping.edition) {
      let url = appIntl.urlPrefix + 'editor/' + entityId;
      /** as an alternative to a hard reload we could use -> window.location.href = url; */
      history.push(url);
    } else if (action === entityMetaMapping.orderItem) {
      let url = appIntl.urlPrefix + 'account/orders/' + entityId;
      /** as an alternative to a hard reload we could use -> window.location.href = url; */
      history.push(url);
    }
  };

  renderNotifications = () => {
    const { notifications } = this.props;
    const { showMessages } = this.state;

    const visibleNotifications = notifications.slice(0, showMessages).map(this.renderNotification);
    const remainingNotifications = notifications.length - visibleNotifications.length;

    if (remainingNotifications > 0) {
      return [
        ...visibleNotifications,
        <div className="p-t-10 text-center more_notifications" key="more">
          <Button variant="link" onClick={this.showMoreMessages}>
            <FormattedMessage
              id="more_notifications"
              values={{ count: remainingNotifications }}
            />
          </Button>
        </div>,
      ];
    } else {
      return visibleNotifications;
    }
  };


  getText = () => {
    const { unreadNotifications } = this.state;
    const { label } = this.props;
    const { notifications } = this.props;
    return (
      <>
        {!!label && label}
        {unreadNotifications > 0 && (
          <Badge
            className="overlayer top-left inline fs-10 badge-important"
            style={{ marginTop: '-8px', marginLeft: '14px' }}
          >
            {unreadNotifications}
          </Badge>
        )}
      </>
    );
  };

  getContent = () => {
    const { intl: { messages } } = this.props;
    const { notifications } = this.props;
    const { unreadNotifications } = this.state;
    return (
      <div className="clearfix menu-dropdown">
        <div
          className="dropdown-menu bg-transparent"
          style={{ position: 'static', display: 'block', float: 'none' }}
        >
          <div className="notification-div">
            <div className="clearfix">
              {!!notifications.length && (
                <div className="pull-left padding-15 count-notifications">
                  <p>
                    <FormattedMessage id="count_notifications" values={{ count: notifications.length }} />
                    <br/>
                    <FormattedMessage id="count_unread_notifications" values={{ count: unreadNotifications }} />
                  </p>
                </div>
              )}
              {!notifications.length &&
                <h5 className="padding-15">{messages.no_notifications}</h5>
              }
              <ul className="dropdown-menu bg-transparent no-border no-padding no-shadow" style={{ position: 'static', display: 'block', float: 'none' }}>
                {this.renderNotifications()}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { appIntl, layout, onMouseEnter, onMouseLeave, currentIndex, animatingOut } = this.props;
    return (
      <MainMenuLinkNotification
        flipId=""
        index={this.index}
        currentIndex={currentIndex}
        layout={layout}
        onMouseEnter={onMouseEnter}
        onDropdownClose={onMouseLeave}
        hasDropdown
        animatingOut={animatingOut}
        id="menu-notifications"
        link={`/${appIntl.locale}/account/notifications`}
        className="relative"
        text={
          <span>
            <i className="fa-solid fa-bell"></i>
            {this.getText()}
          </span>
        }
        dropdownWidth={275}
        listClassName="menu-notifications"
        dropdownMenuElements={[
          {
            content: [{ type: 'raw', params: [{ name: 'content', value: this.getContent() }] }],
            language: appIntl.locale,
          },
        ]}
      />
    );
  }
}

const mapStateToProps = state => ({
  appIntl: state.intl,
  projectConfig: state.data.projectConfig,
  user: state.login.user,
  notifications: state.realTimeNotifications.notifications,
  latestNotification: state.realTimeNotifications.latestNotification,
  goToData: state.realTimeNotifications.goToData
});

const mapDispatchToProps = dispatch => ({
  getAllNotificationsR: option => dispatch(getAllNotificationsR(option)),
  connectNotificationsSocket: () => dispatch(socketConnectNotifications()),
  setAsReadR: id => dispatch(setAsReadR(id)),
  doNotify: (code, text, notificationId, actionTitle) => {
    const setAsRead = {
      action: JSON.stringify({
        type: "SET_READ_AND_GO_TO",
        payload: {
          id: notificationId,
        },
      }),
      title: actionTitle,
    };
    dispatch(addNotification(code, text, {actions: [setAsRead]}));
  },
});

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(NotificationMenu)));
